<div class="card ">
    <div class="card-body">
        <div class="d-flex">
            <div>
                <h4 class="strong card-title">{{vehicle.regoNo}} {{vehicle.state}}</h4>
            </div>
            <div class="ml-auto">
                <span *ngIf="vehicle.status=='Active' && vehicle.isRemovalRequested"
                    class="badge badge-pill badge-warning">Removal Pending</span>
                <span *ngIf="vehicle.status=='Active' && !vehicle.isRemovalRequested"
                    class="badge badge-pill badge-success">Active</span>
                <span *ngIf="vehicle.status=='Cancelled'" style="background-color:#555555"
                    class="badge badge-pill badge-secondary">Inactive</span></div>
        </div>
        <div class="d-flex">
            <div class="card-subtitle text-muted">
                <span *ngIf="!!vehicle.vehicleType || !!vehicle.vehicleMake ">{{vehicle.vehicleMake}}
                    {{vehicle.vehicleType}}</span>
            </div>
            <div class="card-subtitle text-muted ml-auto">
                {{vehicle.capacity}} Litres
            </div>
        </div>
        <div>
            
            <div>
                <div class="row">
                    <div class="col pt-2">
                        <label>Registered On</label>
                        <div>{{vehicle.startDate | date :"dd/MM/yyyy"}}</div>
                    </div>
                    <div class="col pt-2">
                        <label *ngIf="!vehicle.isExpired">Expires On</label>
                        <label *ngIf="vehicle.isExpired">Expired On</label>
                         <div>{{vehicle.endDate | date :"dd/MM/yyyy"}}</div>
                     </div>
                </div>
                <div class="row">
                    <div class="col pt-2"><label>Device No</label>
                        <div *ngIf="vehicle.hasDevice">{{vehicle.deviceNo}}</div>
                        <div *ngIf="!vehicle.hasDevice">Not Installed</div>
                    </div>
                    <div class="col pt-2"><label>Backflow Prevention Device</label>
                        <div>
                            <span *ngIf="vehicle.isAirGap">Air Gap&nbsp;</span>
                            <span *ngIf="vehicle.isRPZD">RPZD&nbsp;</span>
                            <span *ngIf="!vehicle.isRPZD && !vehicle.isAirGap">Not Specified</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pt-2">
                        <div *ngIf="vehicle.hasDevice">
                            <label>Installed On</label>
                            <div>{{vehicle.commissionDate | date :"dd/MM/yyyy" }}</div>
                        </div>
                    </div>
                    <div class="col pt-2"><label>Backflow Prevention Certificate</label>
                        <div *ngIf="!!vehicle.certificateIssueDate">Issued
                            {{vehicle.certificateIssueDate | date :"dd/MM/yyyy"}}
                        </div>
                        <div *ngIf="!vehicle.certificateIssueDate">Not Issue Date Specified</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="vehicle.status=='Active'">
            <div class="col-12 pt-2">
                <label>Uploaded Certificates</label>
                <cli-file-upload 
                #fileUploadComponent
                [allowComments]="false" 
                [objectId]="vehicle.vehicleId" 
                [objectType]="'Vehicle'"
                [fileList]="vehicle.fileList" 
                [isUploadButtonShown]="false"
                (fileUploaded)="onFileUploaded($event)"
                (fileRemoved)="onFileRemoved($event)">
                </cli-file-upload>
            </div>
         
        </div>

        <div class="pt-2 d-flex justify-content-end">
            <div *ngIf="vehicle.status=='Active'"><button (click)="uploadCertificate()"
                class="btn btn-sm btn-link">Upload Certificate</button></div>
            <div *ngIf="vehicle.status=='Active' && !vehicle.isRemovalRequested"><button (click)="editVehicle()"
                    class="btn btn-sm btn-link">Edit Vehicle</button></div>
            <div *ngIf="vehicle.status=='Active' && !vehicle.isRemovalRequested"><button (click)="requestRemoval()"
                    class="btn btn-sm btn-link">Remove Vehicle</button></div>
            
        </div>
    </div>
</div>
<cli-yes-cancel-modal #requestRemovalModal [id]="'requestRemoval' + vehicle.vehicleId"
    [message]="'Are you sure you want to make this vehicle inactive?'"></cli-yes-cancel-modal>